import { SharedMarketType } from '@shared/types'
import type { BffDerivativeMarket, SharedUiMarketSummary } from '@shared/types'
import type { UiMarketAndSummary } from '@/types/trade'

export function getMarketByIdOrSlug(
  markets: BffDerivativeMarket[],
  marketIdOrSlug: string
) {
  return markets.find(
    (market) =>
      market.marketId === marketIdOrSlug || market.slug === marketIdOrSlug
  )
}

export function getPerpetualMarkets(markets: BffDerivativeMarket[]) {
  return markets.filter(
    (market) => market.subType === SharedMarketType.Perpetual
  )
}

export function getExpiryFuturesMarkets(markets: BffDerivativeMarket[]) {
  return markets.filter((market) => market.subType === SharedMarketType.Futures)
}

export function getActiveMarketIds(markets: BffDerivativeMarket[]) {
  return markets
    .filter((market) => market.isVerified)
    .map((market) => market.marketId)
}

export function getTradableDenoms(markets: BffDerivativeMarket[]) {
  return getUniqueDenoms(markets.filter((market) => market.isVerified))
}

export function getUnverifiedDenoms(markets: BffDerivativeMarket[]) {
  return getUniqueDenoms(markets.filter((market) => !market.isVerified))
}

export function getMarketsWithSummary(
  markets: BffDerivativeMarket[],
  summaries: SharedUiMarketSummary[]
) {
  const summaryByMarketId = new Map(
    summaries.map((summary) => [summary.marketId, summary])
  )
  const marketsWithSummary: UiMarketAndSummary[] = []

  for (const market of markets) {
    const summary = summaryByMarketId.get(market.marketId)

    if (!summary) {
      continue
    }

    marketsWithSummary.push({ market, summary })
  }

  return marketsWithSummary
}

function getUniqueDenoms(markets: BffDerivativeMarket[]) {
  return [
    ...markets.reduce((denoms, market) => {
      denoms.add(market.quoteDenom)

      return denoms
    }, new Set<string>())
  ]
}
